import "common/ajax_status";
import "common/customer/autofocus";
import initPrint from "common/customer/print";
import initTooltipOnLoad from "common/customer/tooltip";

document.addEventListener("DOMContentLoaded", () => {
  initPrint();
  initTooltipOnLoad();
});
